import React from "react";
import DragRail from "web/react/components/drag-rail/drag-rail";
import LazyLoadImage from "web/react/components/lazy-load-image/lazy-load-image";
import styles from "./homepage-breakout-brands.css";

interface TitleItemProps {
    title: string;
}

export function TitleItem({ title }: TitleItemProps): JSX.Element {
    return (
        <div className={styles.titleItem}>
            <p className={styles.title}>{title}</p>
        </div>
    );
}

interface Link {
    title: string;
    image_url: string;
    image_alt: string;
    url: string;
}

interface LinkItemProps {
    link: Link;
}

export function LinkItem({ link }: LinkItemProps): JSX.Element {
    return (
        <a className={styles.link} href={link.url}>
            <h4 className={styles.linkTitle}> {link.title} </h4>
            <LazyLoadImage className={styles.linkImage} src={link.image_url} alt={link.image_alt} />
        </a>
    );
}

export interface HomepageBreakoutBrandsProps {
    designer_title: string;
    designer_links: Link[];
    top_dc_title: string;
    top_dc_links: Link[];
    bottom_dc_title: string;
    bottom_dc_links: Link[];
}

function HomepageBreakoutBrands({
    designer_title: designerTitle,
    designer_links: designerLinks,
    top_dc_title: topDesignerCategoryTitle,
    top_dc_links: topDesignerCategoryLinks,
    bottom_dc_title: bottomDesignerCategoryTitle,
    bottom_dc_links: bottomDesignerCategoryLinks,
}: HomepageBreakoutBrandsProps): JSX.Element {
    return (
        <div className={styles.homepageBreakoutBrandsWrapper}>
            <DragRail id="homepage-designer-rail" className={styles.dragRail}>
                <div className={styles.itemsContainer}>
                    <TitleItem title={designerTitle} />
                    {designerLinks.map((designerLink) => {
                        return <LinkItem key={designerLink.title} link={designerLink} />;
                    })}
                </div>
            </DragRail>

            <DragRail id="homepage-top-dc-rail" className={styles.dragRail}>
                <div className={styles.itemsContainer}>
                    {topDesignerCategoryLinks.slice(0, 2).map((topDesignerCategoryLink) => {
                        return (
                            <LinkItem
                                key={topDesignerCategoryLink.title}
                                link={topDesignerCategoryLink}
                            />
                        );
                    })}
                    <TitleItem title={topDesignerCategoryTitle} />
                    {topDesignerCategoryLinks.slice(2).map((topDesignerCategoryLink) => {
                        return (
                            <LinkItem
                                key={topDesignerCategoryLink.title}
                                link={topDesignerCategoryLink}
                            />
                        );
                    })}
                </div>
            </DragRail>

            <DragRail id="homepage-bottom-dc-rail" className={styles.dragRail}>
                <div className={styles.itemsContainer}>
                    {bottomDesignerCategoryLinks.slice(0, 1).map((bottomDesignerCategoryLink) => {
                        return (
                            <LinkItem
                                key={bottomDesignerCategoryLink.title}
                                link={bottomDesignerCategoryLink}
                            />
                        );
                    })}
                    <TitleItem title={bottomDesignerCategoryTitle} />
                    {bottomDesignerCategoryLinks.slice(1).map((bottomDesignerCategoryLink) => {
                        return (
                            <LinkItem
                                key={bottomDesignerCategoryLink.title}
                                link={bottomDesignerCategoryLink}
                            />
                        );
                    })}
                </div>
            </DragRail>
        </div>
    );
}

export default HomepageBreakoutBrands;
